import { gql } from '@urql/core';
import { PlayerMyProfileDocument, PlayerMyProfileQuery, PlayerMyProfileQueryVariables } from 'generated/spin-graphql';
import Link from 'next/link';
import React, { useMemo } from 'react';
import { AppStateUser } from '../../../client/providers/AppProvider';
import { useAuthenticatedQuery } from '../../../client/hooks';
import { GenericInLayoutPageLoading } from '../../common/GenericFullPageLoading';
import { PlayerProfile } from '../../players/PlayerProfile';

gql`
    query PlayerMyProfile($id: uuid!) {
        espin_player_profile_by_pk(id: $id) {
            ...PlayerProfile
        }
    }
`;

export function PlayerMyProfile({ user }: { user: AppStateUser }) {
    const { isReady, data } = useAuthenticatedQuery<PlayerMyProfileQuery, PlayerMyProfileQueryVariables>(
        {
            query: PlayerMyProfileDocument,
            variables: useMemo(() => ({ id: user.player_profile?.id }), [user]),
            pause: !!!user.player_profile,
        },
        ['espin_player_profile'],
    );

    if (!isReady) {
        return <GenericInLayoutPageLoading />;
    }

    return (
        <div className="player-my-profile-container">
            <div className="profile-container">
                <PlayerProfile player={data.espin_player_profile_by_pk} />
            </div>
            <Link href="/dashboard/my-profile/edit">
                <a className="button large-button blue-button">Edit Profile</a>
            </Link>
        </div>
    );
}
